import React from 'react';
import { usePrivy, useWallets } from '@privy-io/react-auth';
import { StyledButton } from '../components/ui/StyledButton';
import { Unplug } from 'lucide-react';

const PrivyAuth = ({ onConnect, onStatusChange, onDisconnect }) => {
  const { login, logout, authenticated, user } = usePrivy();
  const { wallets } = useWallets();

  const handleConnect = async () => {
    try {
      onStatusChange('连接 Connecting...');
      await login();
    } catch (error) {
      console.error(error);
      onStatusChange('连接失败 Connection failed');
    }
  };

  const handleDisconnect = async () => {
    try {
      await logout();
      onDisconnect();
      onStatusChange('断开连接 Disconnected');
    } catch (error) {
      console.error(error);
      onStatusChange('断开连接失败 Disconnect failed');
    }
  };

  React.useEffect(() => {
    if (authenticated && wallets.length > 0) {
      const wallet = wallets[0];
      onConnect(wallet.address);
      onStatusChange(`已连接 Connected: ${wallet.address.slice(0, 6)}...${wallet.address.slice(-4)}`);
    }
  }, [authenticated, wallets, onConnect, onStatusChange]);

  return authenticated ? (
    <StyledButton onClick={handleDisconnect}>
      
<div className="flex flex-center"><Unplug/> <span className="ml-2">断开 (Disconnect)</span></div>
      </StyledButton>
  ) : (
    <StyledButton onClick={handleConnect}>连接钱包 (Connect Wallet)</StyledButton>
  );
};

export default PrivyAuth;
